module.exports = __webpack_public_path__ + "img/scatter.7c342cde.png";